export const heroContent = {
  badge: "Profesionalna bezbednosna rešenja",
  title: "Kompletna zaštita\nvašeg prostora",
  subtitle: "IP kamere, video interfoni, kontrola pristupa i alarmni sistemi za dom i biznis. Više od 15 godina iskustva u bezbednosnim sistemima.",
  ctaPrimary: "Pogledajte proizvode",
  ctaSecondary: "Besplatna konsultacija",
  bottomSlogan: "SAFEGUARD",
  stats: [
    { value: "15+", label: "Godina iskustva" },
    { value: "5,000+", label: "Instaliranih sistema" },
    { value: "24/7", label: "Tehnička podrška" },
    { value: "98%", label: "Zadovoljnih klijenata" },
  ],
};

export const aboutContent = {
  label: "O nama",
  title: "Vaš partner za bezbednost",
  description: "Već više od 15 godina pružamo vrhunska rešenja za kontrolu pristupa, video nadzor i zaštitu objekata širom Srbije. Naš tim sertifikovanih inženjera projektuje, instalira i održava sisteme bezbednosti za stambene i poslovne objekte. Verujemo da je bezbednost osnovno ljudsko pravo — i da svako zaslužuje miran san.",
  stats: [
    { value: "5,000+", label: "Instaliranih sistema" },
    { value: "15+", label: "Godina iskustva" },
    { value: "50+", label: "Stručnjaka u timu" },
    { value: "24/7", label: "Monitoring centar" },
  ],
};

export const categoriesContent = [
  {
    title: "Video\nNadzor",
    subtitle: "IP Kamere",
    description: "4K kamere sa AI detekcijom, noćnim vidom i cloud storage-om.",
    icon: "ri-camera-line",
    type: "dark" as const,
    slug: "kamere",
  },
  {
    title: "Kontrola\nPristupa",
    subtitle: "Siguran ulaz",
    description: "RFID kontroleri, pametne brave i biometrijski čitači za potpunu kontrolu.",
    icon: "ri-shield-keyhole-line",
    type: "light" as const,
    slug: "kontrola-pristupa",
  },
  {
    title: "Video\nInterfoni",
    subtitle: "Pametna komunikacija",
    description: "IP video interfoni sa ekranom na dodir, WiFi konekcijom i aplikacijom.",
    icon: "ri-smartphone-line",
    type: "light" as const,
    slug: "video-interfoni",
  },
];

export const ctaContent = {
  title: "Spremni da zaštitite svoj prostor?",
  description: "Zakažite besplatnu konsultaciju sa našim stručnjacima. Dolazimo na lokaciju, radimo procenu i dajemo konkretan predlog — potpuno besplatno.",
  button: "Zakažite konsultaciju",
};

export const solutionsContent = [
  {
    title: "Video Nadzor",
    subtitle: "IP Kamere i NVR sistemi",
    description: "Profesionalne IP kamere sa 4K rezolucijom, AI detekcijom lica i vozila, noćnim vidom u boji. NVR snimači sa do 30 dana neprekidnog snimanja i cloud backup opcijom.",
    icon: "ri-camera-line",
    image: "https://readdy.ai/api/search-image?query=Professional%20IP%20security%20camera%20array%20on%20modern%20building%2C%20sleek%20surveillance%20technology%20concept%2C%20clean%20urban%20architecture%20background%2C%20corporate%20security%20aesthetic%2C%20soft%20natural%20lighting%20with%20blue%20sky%2C%20daytime%20professional%20photography&width=1200&height=500&seq=solution-cameras&orientation=landscape",
  },
  {
    title: "Kontrola Pristupa",
    subtitle: "RFID i Biometrija",
    description: "RFID kontroleri, biometrijski čitači otiska prsta i pametne brave. Upravljanje dozvolama za do 10,000 korisnika sa web panelom i mobilnom aplikacijom.",
    icon: "ri-shield-keyhole-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20RFID%20access%20control%20reader%20on%20office%20wall%2C%20sleek%20security%20device%20design%2C%20professional%20corporate%20interior%2C%20clean%20technology%20aesthetic%2C%20soft%20ambient%20office%20lighting&width=800&height=600&seq=solution-access&orientation=landscape",
  },
  {
    title: "Video Interfoni",
    subtitle: "Pametna komunikacija na vratima",
    description: "IP video interfoni sa ekranom osetljivim na dodir, WiFi konekcijom i mobilnom aplikacijom. Vidite, razgovarajte i otključajte vrata sa bilo kog mesta.",
    icon: "ri-smartphone-line",
    image: "https://readdy.ai/api/search-image?query=Elegant%20video%20intercom%20system%20on%20modern%20apartment%20entrance%2C%20sleek%20touchscreen%20indoor%20unit%2C%20contemporary%20residential%20design%2C%20warm%20natural%20lighting%2C%20smart%20home%20technology%20aesthetic&width=800&height=600&seq=solution-intercom&orientation=landscape",
  },
  {
    title: "Alarmni Sistemi",
    subtitle: "24/7 Zaštita i monitoring",
    description: "Bežični alarmni sistemi sa 20 zona, GSM/4G backup komunikacijom, integracijom kamera i profesionalnim monitoring centrom. Push notifikacije i daljinsko upravljanje.",
    icon: "ri-alarm-warning-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20wireless%20alarm%20system%20control%20panel%20with%20sensors%2C%20contemporary%20security%20equipment%2C%20clean%20residential%20interior%20background%2C%20professional%20technology%20aesthetic%2C%20soft%20diffused%20lighting&width=800&height=600&seq=solution-alarm&orientation=landscape",
  },
];

export const footerContent = {
  company: "SafeGuard Systems",
  tagline: "Vaša bezbednost je naša misija.",
  copyright: "© 2026 SafeGuard Systems. Sva prava zadržana.",
  links: {
    product: [
      { label: "IP Kamere", href: "#" },
      { label: "Video zvona", href: "#" },
      { label: "Video interfoni", href: "#" },
      { label: "Kontrola pristupa", href: "#" },
      { label: "Alarmni sistemi", href: "#" },
    ],
    company: [
      { label: "O nama", href: "#" },
      { label: "Projekti", href: "#" },
      { label: "Partneri", href: "#" },
      { label: "Karijera", href: "#" },
      { label: "Blog", href: "#" },
    ],
    support: [
      { label: "Kontakt", href: "#" },
      { label: "Tehnička podrška", href: "#" },
      { label: "Garancija", href: "#" },
      { label: "Dostava", href: "#" },
    ],
  },
};